<template>
	<div id="top">
		<div class="main" v-if="currentNode">
			<ul class="main-modes">
				<li
					class="main-mode"
					:class="{ 'main-mode--active': currentHomePage == 'read' }"
					@click.prevent="clickTab('read')"
				>
					<p>Описание</p>
				</li>
				<li
					v-if="isNormalPropertyExist"
					class="main-mode"
					:class="{ 'main-mode--active': currentHomePage == 'norma' }"
					@click.prevent="clickTab('norma')"
				>
					<p>Норма</p>
				</li>
				<li
					v-if="isNotNormalPropertyExist"
					class="main-mode"
					:class="{ 'main-mode--active': currentHomePage == 'potalogy' }"
					@click.prevent="clickTab('potalogy')"
				>
					<p>Патология</p>
				</li>
			</ul>

			<div class="main-content">
				<System :page="currentHomePage" :systemID="systemID" :mobile="mobile" />
			</div>
		</div>

		<v-overlay :value="loadingContent" absolute>
			<v-progress-circular indeterminate size="64" />
		</v-overlay>
	</div>
</template>

<script>
// import Header from "../components/Header/Header.vue";
// import SideMenu from "../components/SideMenu/SideMenu.vue";
import System from "../components/System/System.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
	name: "Home",
	props: {
		systemID: { type: String, default: () => 0, required: true }
	},
	components: {
		// Header,
		System,
		// SideMenu,
	},
	data() {
		return {
			loadingContent: true,
			currentHomePage: "read",
			prevPage: "",
			query: {
				nodeid: '',
				isnormal: true
			},
			isNormalPropertyExist: false,
			isNotNormalPropertyExist: false
		};
	},
	methods: {
		...mapActions({
			getNode: "tree/getNode",
			nodeComplete: "user/nodeComplete",
			getPropertyFiles: "property/getPropertyFiles"
		}),
		...mapMutations({
			setHeadList: "tree/setHeadList",
		}),
		clickTab(name) {
			this.currentHomePage = name
		},
	},
	computed: {
		...mapGetters({
			currentNode: "tree/currentNode",
			getFiles: 'property/getFiles',
		}),
	},
	created() {
		setTimeout(() => {
			this.nodeComplete(this.systemID)
		}, 5000)
		this.getNode({id:this.systemID, media: true})
		.then(res => {

			if(res.data.content) {
				let list = []
				let content = document.querySelector('.system_content')
				content.querySelectorAll('h1, h2').forEach((item, index) => {
					item.id = `h-${index}`
					list.push({href: item.id, text: item.innerText, class: item.localName})
				})
				this.setHeadList(list)
			}
			this.query.id = this.systemID

			// this.getPropertyFiles(this.query)
			// .then(() => {
			// 	this.query.isnormal = !this.query.isnormal
			// 	this.getPropertyFiles(this.query)
			// })
			
			this.isNormalPropertyExist = res.data.isNormalPropertyExist
			this.isNotNormalPropertyExist = res.data.isNotNormalPropertyExist
			
			this.loadingContent = false
		})

		this.mobile = window.document.documentElement.clientWidth <= 960;
	}
};
</script>

<style lang="scss" scoped>
@import "~@/scss/vars.scss";

.main {
  display: flex;
  flex-direction: row;
  min-height: calc(100vh - 64px);
  margin: 0;
  padding: 0;
  background: #fff;
}

.main-content {
  display: flex;
  flex-flow: column;
  max-width: 100%;
  width: 100%;
  margin: 100px 0 0 75px;
  padding: 0 32px;
  overflow: auto;
}

.main-close {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 40px;
  height: 40px;
  top: 35px;
  right: 30px;
  z-index: 100;
  background: url("~@/assets/img/cross.svg") no-repeat;
  background-position: center;
  background-size: 50%;
}

.main-modes {
  display: flex;
  position: absolute;
  margin: 0 !important;
  padding: 0 !important;
  top: 35px;
  right: 105px;
  list-style-type: none;
  background: #f3f4f6;
  border: 2px solid #f3f4f6;
  border-radius: 7px;
  z-index: 5;
}

.main-mode {
  display: flex;
  border-radius: 7px;
  padding: 6px 0;
  cursor: pointer;
  & p {
	margin: 0 !important;
	color: #000;
	padding: 0 17px;
	border-right: 1px solid #8e8e93;
  }
  &:last-child p {
	border: none;
  }
}

.main-mode--active {
  background: #4854fe;

  & p {
	border: none;
	color: #fff;
  }
}

@media screen and (max-width: 960px) {
  .main {
	flex-flow: column;
  }

  .main-content {
	margin: 80px 0 20px;
	padding: 0 16px;
  }

  .main-modes {
	top: 72px;
	right: 16px;
	height: min-content;
	width: min-content;
  }

  .main-close {
	top: 120px;
	right: 10px;
  }
}
</style>
